import { StyleSheet } from 'react-native';

import { blackTransparent } from 'utils/colors';
import { isTablet } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        marginLeft: isTablet ? 44 : 16,
        width: 32,
        borderRadius: 16,
        aspectRatio: 1,
        backgroundColor: blackTransparent(0.7),
    },
});

export default styles;
